import React from 'react'
import { useVersionCheck } from '../hooks/useVersionCheck'

/**
 * Composant qui affiche une bannière quand une mise à jour est disponible
 * Se place en haut de l'écran de manière fixe
 */
export function UpdateNotification() {
  const { updateAvailable, refresh } = useVersionCheck()

  if (!updateAvailable) return null

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-news text-base-dark px-4 py-3 shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center">
          <svg
            className="w-5 h-5 mr-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
          <span className="text-sm font-bold">
            Une nouvelle version de l'application est disponible
          </span>
        </div>
        <button
          onClick={refresh}
          className="ml-4 px-4 py-1.5 bg-base text-white text-sm font-medium rounded hover:bg-base-dark transition-colors"
        >
          Mettre à jour
        </button>
      </div>
    </div>
  )
}
